import React from "react";


const About = () => {
  return (
    <div className="about-page">
      <div className="about-text">
        <h1>About Us</h1>
        <p>
          Welcome to our company! We are a team of passionate developers who
          specialize in building dynamic user interfaces with React. Our mission
          is to create high-quality, modern web applications that solve real-world
          problems.
        </p>
      </div>
    </div>
  );
};

export default About;
